export default "__VITE_ASSET__Cw7Pp4SY__"